// import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
// import { cx } from 'cva';
import { type FunctionComponent } from 'react';
import styles from './Checkbox.module.css';

export type CheckboxProps = {
  checked: boolean;
  disabled: boolean;
  onClick: () => void;
};

export const Checkbox: FunctionComponent<CheckboxProps> = ({
  checked,
  disabled,
  onClick,
}: CheckboxProps) => {
  return (
    <label className={styles.checkboxWrapper}>
      <input
        checked={checked}
        disabled={disabled}
        onChange={onClick}
        readOnly
        type="checkbox"
      />
      <span className={styles.checkmark} />
    </label>
  );

  /*
  return (
    <CheckboxPrimitive.Root
      checked={checked}
      className={cx(styles.checkbox, className)}
      onClick={onClick}
    >
      <CheckboxPrimitive.Indicator>
        <CheckIcon className={styles.checkIcon} />
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  );
  */
};
